import InfinityLoader from 'ember-infinity/components/infinity-loader';

export default InfinityLoader;
